module.exports = __webpack_public_path__ + "static/media/BB_Positive_Control.95554f23.svg";